import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import MenuIcon from '@mui/icons-material/Menu'
import Divider from '@mui/material/Divider'
import MuiDrawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import { styled } from '@mui/material/styles'
import * as React from 'react'
import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'


import surveyicon from 'assets/side_panel_icons/6order.png'
import userInfo from 'utils/userInfo'
import registration from 'assets/side_pane_new_icons/createuser.svg'
import faq from 'assets/side_pane_new_icons/faqin.svg'
import home from 'assets/side_pane_new_icons/home.svg'
import task from 'assets/side_pane_new_icons/note.svg'
import notes from 'assets/side_pane_new_icons/sticky.png'


import teams from 'assets/side_pane_new_icons/team.svg'
import docs from 'assets/side_pane_new_icons/document.svg'
import stream from 'assets/side_panel_icons/5stream.png'

import project from 'assets/side_pane_new_icons/project.svg'
import publication from 'assets/side_panel_icons/publication.png'
import struc from 'assets/side_pane_new_icons/building.svg'
import download from 'assets/side_pane_new_icons/downloadin.svg'
import money from 'assets/side_panel_icons/money.png'
import table from "assets/side_panel_icons/tabel.png"
import leftwindow from "assets/side_panel_icons/windowsleft.png"
import rightwindow from "assets/side_panel_icons/windowsright.png"
import archive from "assets/side_pane_new_icons/sticky.png"
import stylesB from './MenuW.module.scss'
import stylesW from './MenuW.module.scss'

import {
  postUserInfo,
} from "service/AuthService";
import {
  changeNavigatePosition
} from "store/slices/UserSlice";

//check color
const usertheme = userInfo()?.them;
let backgroundColor
let textColor
let invertLevel
if (usertheme) {
  backgroundColor = "#white"
  textColor = "black"
  invertLevel = "invert(0.8)"
}
else {
  backgroundColor = "white"
  textColor = "black"
  invertLevel = "invert(0.8)"
}
//end check

const drawerWidth = 270

const openedMixin = (theme) => ({
  width: drawerWidth,
  borderRight: 'unset',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  '& img': {
    width: '19px',
    // height: '26px',
    marginBottom: '3px',
    filter: invertLevel,
  },

  '& p': {
    paddingLeft: '10px',
  },
})

const closedMixin = (theme) => ({
  transition: theme?.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  borderRight: 'unset',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
  textAligh: 'center',
  '& img': {
    // Задаем стили для всех img элементов внутри контейнера, к которому применяется этот mixin
    width: '19px', // Замените на нужные стили
    // height: '26px', // Замените на нужные стилие
    // Замените на нужные стили
    marginBottom: '3px',
    filter: invertLevel,
  },
  '& p': {
    paddingLeft: '10px',
    marginBottom: '5px',
  },
})

const StyledDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',

  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}))


// Местоположение
// Объявление глобальных переменных
let positionx = "0";
let positiony = "auto";


function move_info() {
  const user_info = userInfo();

  if (user_info?.menu_navigate_position === true) {
    const element = document.getElementById('laylayoutout');
    positionx = 'auto';
    positiony = '0';
    element.style.paddingRight = '54px';
    element.style.paddingLeft = '8px';
  }
  else {
    const element = document.getElementById('laylayoutout');
    positionx = '0';
    positiony = 'auto';
    element.style.paddingRight = '8px';
    element.style.paddingLeft = '57px';

  }
}

function move(direction, setOpen) {
  const user_info = userInfo();
  const element = document.getElementById('laylayoutout');

  if (direction === 'left') {
    positionx = '0';
    positiony = 'auto';
    element.style.paddingRight = '8px';
    element.style.paddingLeft = '57px';



  } else if (direction === 'right') {
    positionx = 'auto';
    positiony = '0';
    element.style.paddingRight = '54px';
    element.style.paddingLeft = '8px';

  }
  let data;

  const postData = async () => {

    try {
      let response = await postUserInfo(user_info.userId, data);
      const user_change = JSON.parse(localStorage.getItem('user'));
      user_change.menu_navigate_position = response.data.info;
      user_change.userInfo.menu_navigate_position = response.data.info;
      localStorage.setItem('user', JSON.stringify(user_change));
    } catch (error) {
      console.log("CHU")
    }

  };
  postData()
  setOpen(false)
}





const Drawer = styled(MuiDrawer, {

  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',

  borderRight: 'unset',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': {
      ...openedMixin(theme),
      left: positionx,
      right: positiony,
      background: backgroundColor,
      // Background color with 32% opacity
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': {
      ...closedMixin(theme),
      left: positionx,
      right: positiony,

      background: backgroundColor, // Background color with 32% opacity
    },
  }),
}))

export default function MenuDrawer() {
  const user_info = userInfo();
  const [styles, setThem] = useState(stylesW)
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  const user = userInfo()

  const location = useLocation()
  const handleMouseEnter = () => {
    setOpen(true)
  }

  const handleMouseLeave = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (user?.them) {
      setThem(stylesW)
    }
    else {
      setThem(stylesB)
    }
    move_info()
  }, []);
  return (
    <div>
      <Drawer
        variant="permanent"
        open={open}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}

      >
        <StyledDrawerHeader >

          {/* {open ?     <div className={styles.logo__wrapper}>
          <img src={unetLogo} alt="" />
        </div> :  null} */}
          {open ? (
            <div className={styles.logo__wrapper}>
              <p style={{ color: textColor }}>Навигация</p>
            </div>
          ) : null}

          <IconButton
            sx={{ color: textColor, paddingRight: '8px' }}
            aria-label="open drawer"
            onClick={() => setOpen((prevOpen) => !prevOpen)}
            edge="start"
          >
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
        </StyledDrawerHeader>
        <Divider />
        <div className={styles.menu__list}>
          <List >

            <div className={styles.menu__section}>
              <div>
                <ListItemButton
                  disablePadding
                  onClick={() => navigate(`/home/`)}
                  style={
                    location.pathname.includes('home')
                      ? { background: '#E8E8EF' }
                      : {}
                  }
                >
                  <img style={
                    location.pathname.includes('home')
                      ? { filter: 'invert(0.8)' }
                      : {}
                  } className={styles.image_icon} src={home} alt="" />
                  {open ? <p style={
                    location.pathname.includes('home')
                      ? { color: 'black' }
                      : {}
                  }>Главная</p> : null}
                </ListItemButton>

                <ListItemButton
                  disablePadding
                  onClick={() => navigate(`/tests/`)}
                  style={
                    location.pathname.includes('tests') ||
                      location.pathname.includes('/tests')
                      ? { background: '#E8E8EF' }
                      : {}
                  }
                >
                  <img style={
                    location.pathname.includes('tests') ||
                      location.pathname.includes('/tests')
                      ? { filter: 'invert(0.8)' }
                      : {}
                  } className={styles.image_icon} src={stream} alt="" />

                  {open ? <p style={
                    location.pathname.includes('tests')
                      ||
                      location.pathname.includes('/tests')
                      ? { color: 'black' }
                      : {}
                  }>Тесты</p> : null}
                </ListItemButton>
                <ListItemButton
                  disablePadding
                  onClick={() => navigate(`/surveys/`)}
                  style={
                    location.pathname.includes('surveys') ||
                      location.pathname.includes('/surveys')
                      ? { background: '#E8E8EF' }
                      : {}
                  }
                >
                  <img style={
                    location.pathname.includes('surveys') ||
                      location.pathname.includes('/surveys')
                      ? { filter: 'invert(0.8)' }
                      : {}
                  } className={styles.image_icon} src={surveyicon} alt="" />

                  {open ? <p style={
                    location.pathname.includes('surveys')
                      ||
                      location.pathname.includes('/surveys')
                      ? { color: 'black' }
                      : {}
                  }>Анкетирование</p> : null}
                </ListItemButton>
                <ListItemButton
                  disablePadding
                  onClick={() => navigate(`/statements/`)}
                  style={
                    location.pathname.includes('statement')
                      ? { background: '#E8E8EF' }
                      : {}
                  }
                >
                  <img style={
                    location.pathname.includes('statement')
                      ? { filter: 'invert(0.8)' }
                      : {}
                  } className={styles.image_icon} src={docs} alt="" />

                  {open ? <p style={
                    location.pathname.includes('statement')
                      ? { color: 'black' }
                      : {}
                  } >Документооборот</p> : null}
                </ListItemButton>


                <ListItemButton
                  disablePadding
                  onClick={() => navigate(`/tasks/`)}
                  style={
                    location.pathname.includes('task')
                      ? { background: '#E8E8EF' }
                      : {}
                  }
                >
                  <img style={
                    location.pathname.includes('task')
                      ? { filter: 'invert(0.8)' }
                      : {}
                  } className={styles.image_icon} src={task} alt="" />

                  {open ? <p style={
                    location.pathname.includes('task')
                      ? { color: 'black' }
                      : {}
                  }>Задачи</p> : null}
                </ListItemButton>

                <ListItemButton
                  disablePadding
                  onClick={() => navigate(`/notes/`)}
                  style={
                    location.pathname.includes('notes')
                      ? { background: '#E8E8EF' }
                      : {}
                  }
                >
                  <img style={
                    location.pathname.includes('notes')
                      ? { filter: 'invert(0.8)' }
                      : {}
                  } className={styles.image_icon} src={notes} alt="" />

                  {open ? <p style={
                    location.pathname.includes('notes')
                      ? { color: 'black' }
                      : {}
                  }>Заметки</p> : null}
                </ListItemButton>


                <ListItemButton
                  disablePadding
                  onClick={() => navigate(`/report-card/`)}
                  style={
                    location.pathname.includes("report")
                      ? { background: '#E8E8EF' }
                      : {}
                  }


                >
                  <img style={
                    location.pathname.includes('report')
                      ? { filter: 'invert(0.8)' }
                      : {}
                  } src={table} className={stylesW.image_icon} alt="" />

                  {open ? <p style={
                    location.pathname.includes('report')
                      ? { color: 'black' }
                      : {}
                  }>Таймшит</p> : null}
                </ListItemButton>
                {user.is_admin_of_accountant ? (
                  <ListItemButton
                    disablePadding
                    onClick={() => navigate(`/accounting/`)}
                    style={
                      location.pathname.includes("accounting")
                        ? { background: '#E8E8EF' }
                        : {}
                    }


                  >
                    <img style={
                      location.pathname.includes('accounting')
                        ? { filter: 'invert(0.8)' }
                        : {}
                    } src={money} className={stylesW.image_icon} alt="" />

                    {open ? <p style={
                      location.pathname.includes('accounting')
                        ? { color: 'black' }
                        : {}
                    }>Бухгалтерия</p> : null}
                  </ListItemButton>
                ) : null}
                {user?.is_archivist ? (
                  <ListItemButton
                    disablePadding
                    onClick={() => navigate(`/archive/`)}
                    style={
                      location.pathname.includes("archive")
                        ? { background: '#E8E8EF' }
                        : {}
                    }
                  >
                    <img style={
                      location.pathname.includes('archive')
                        ? { filter: 'invert(0.8)' }
                        : {}
                    } src={archive} className={stylesW.image_icon} alt="" />

                    {open ? <p style={
                      location.pathname.includes('archive')
                        ? { color: 'black' }
                        : {}
                    }>Архив</p> : null}
                  </ListItemButton>
                ) : null}
                {user?.is_admin_of ? (
                  <>
                    <ListItemButton
                      disablePadding
                      onClick={() => navigate(`/structure`)}
                      style={
                        location.pathname.includes('structure')
                          ? { background: '#E8E8EF' }
                          : {}
                      }
                    >
                      <img style={
                        location.pathname.includes('structure')
                          ? { filter: 'invert(0.8)' }
                          : {}
                      } className={styles.image_icon} src={struc} alt="" />

                      {open ? <p style={
                        location.pathname.includes('structure')
                          ? { color: 'black' }
                          : {}
                      }>Компания</p> : null}
                    </ListItemButton>



                    <ListItemButton
                      disablePadding
                      onClick={() => navigate(`/register_person`)}
                      style={
                        location.pathname.includes('register_person')
                          ? { background: '#E8E8EF' }
                          : {}
                      }
                    >
                      <img style={
                        location.pathname.includes('register_person')
                          ? { filter: 'invert(0.8)' }
                          : {}
                      } className={styles.image_icon} src={registration} alt="" />

                      {open ? <p style={
                        location.pathname.includes('register_person')
                          ? { color: 'black' }
                          : {}
                      }>Создать пользователя</p> : null}
                    </ListItemButton>
                  </>
                ) : null}
                <div style={{ padding: "8px 18px" }}>
                  <hr />
                </div>


              </div>
              <div>
                <div style={{ padding: "8px 18px" }}>
                  <hr />
                </div>
                {user_info?.menu_navigate_position ?
                  <>
                    <ListItemButton
                      disablePadding
                      onClick={() => move('left', setOpen)}

                    >
                      <img className={styles.image_icon} src={leftwindow} alt="" />
                      {open ? <p >Поместить слева</p> : null}
                    </ListItemButton>
                    <ListItemButton
                      disablePadding

                      style={{ filter: "invert(0.6)" }}
                    >
                      <img className={styles.image_icon} src={rightwindow} alt="" />
                      {open ? <p >Справа</p> : null}

                    </ListItemButton>
                  </>
                  : <>
                    <ListItemButton
                      disablePadding

                      style={{ filter: "invert(0.6)" }}
                    >
                      <img className={styles.image_icon} src={leftwindow} alt="" />
                      {open ? <p >Слева</p> : null}
                    </ListItemButton>
                    <ListItemButton
                      disablePadding
                      onClick={() => move('right', setOpen)}

                    >
                      <img className={styles.image_icon} src={rightwindow} alt="" />
                      {open ? <p >Поместить справа</p> : null}

                    </ListItemButton>
                  </>}
              </div>
            </div>
          </List>
        </div>
      </Drawer>
    </div>
  )
}
